import React, { useState } from 'react';

const TimeRangeSelector = ({ onTimeRangeChange }) => {
  const [selectedTimeRange, setSelectedTimeRange] = useState('24h');

  const handleChange = (newTimeRange) => {
    setSelectedTimeRange(newTimeRange);
    onTimeRangeChange(newTimeRange);
  };

  return (
    <div className="flex space-x-2 md:mr-8">
      <button
        className={`py-2 px-4 text-sm font-medium rounded ${selectedTimeRange === '24h' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => handleChange('24h')}
      >
        24h
      </button>
      <button
        className={`py-2 px-4 text-sm font-medium rounded ${selectedTimeRange === '7d' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => handleChange('7d')}
      >
        7d
      </button>
      <button
        className={`py-2 px-4 text-sm font-medium rounded ${selectedTimeRange === '30d' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => handleChange('30d')}
      >
        30d
      </button>
      <button
        className={`py-2 px-4 text-sm font-medium rounded ${selectedTimeRange === 'all' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => handleChange('all')}
      >
        All
      </button>
    </div>
  );
};

export default TimeRangeSelector;
